const a = new URL("../../assets/background-button-gray-CHy8Pl8a.png", import.meta.url).href;
export {
  a as default
};
//# sourceMappingURL=background-button-gray.png.js.map
